module.exports = __webpack_public_path__ + "img/mumbojumbo-0375701b-7ae7-4777-dded-08d959eef549.png";